export const fields = {
  slaComment: {
    label: "Comment",
    value: "",
  },
  slaStatusID: {
    label: "SLA Status",
    value: null,
  },
  slaReminderDate: {
    label: "Reminder Date",
    value: null,
  },
  slaRecipient: {
    label: "Reminder to be sent to",
    value: null,
  },
};
